<template>
  <div class="card shadow-sm border-0 rounded-custom mb-4">
    <div class="card-body p-4">
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4">
        <div>
          <h3 class="text-violet text-uppercase h5 mb-1">{{ $t("Filters and export") }}</h3>
          <p class="text-muted mb-0">
            {{ $t("Summary and export follow the records currently filtered.") }}
          </p>
        </div>

        <div class="d-flex flex-wrap gap-2">
          <button
            class="btn btn-outline-violet rounded-pill"
            :disabled="isExporting"
            @click="$emit('export', 'xlsx')"
          >
            {{ exportingFormat === "xlsx" ? $t("Exporting...") : $t("Export Excel") }}
          </button>
          <button
            class="btn btn-outline-secondary rounded-pill"
            :disabled="isExporting"
            @click="$emit('export', 'csv')"
          >
            {{ exportingFormat === "csv" ? $t("Exporting...") : $t("Export CSV") }}
          </button>
        </div>
      </div>

      <div class="row g-3 align-items-end">
        <div class="col-12 col-lg-6">
          <label class="form-label text-uppercase small text-muted mb-2">{{ $t("Quick search") }}</label>
          <input
            :value="searchQuery"
            type="text"
            class="form-control rounded-pill"
            :placeholder="$t('Operator, material, machine, notes...')"
            @input="$emit('update:searchQuery', $event.target.value.trim())"
          />
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label text-uppercase small text-muted mb-2">{{ $t("Month") }}</label>
          <input
            :value="monthFilter"
            type="month"
            class="form-control rounded-pill"
            @input="$emit('update:monthFilter', $event.target.value)"
          />
        </div>

        <div class="col-6 col-lg-1">
          <label class="form-label text-uppercase small text-muted mb-2">{{ $t("Per page") }}</label>
          <select
            :value="itemsPerPage"
            class="form-select rounded-pill"
            @change="$emit('update:itemsPerPage', Number($event.target.value))"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
          </select>
        </div>

        <div class="col-6 col-lg-2 d-grid">
          <button class="btn btn-outline-secondary rounded-pill" @click="$emit('reset')">
            {{ $t("Reset filters") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CamProductionIndexFiltersBar",
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
    monthFilter: {
      type: String,
      default: "",
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    exportingFormat: {
      type: String,
      default: "",
    },
    isExporting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:searchQuery", "update:monthFilter", "update:itemsPerPage", "reset", "export"],
};
</script>
